import PropTypes from 'prop-types';
import React from 'react'

import { Row, Col, List } from 'twyne-new.ui'

import { DndCardDrop, DndContext } from './dnd'
import items from './items'
import { TYPE_LIST, TYPE_OBJECT } from './items/types'

const propTypes = {
  tree: PropTypes.object,
  onChange: PropTypes.func,
};

export default class MappingBuilder extends React.Component {
  state = {
    tree: null,
    loading: false,//remove
    feedback: null//remove
  }

  componentWillMount() {
    const { tree } = this.props
    tree && this.setState({ tree: [tree] })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props) return false
    if (nextState !== this.state) return true
  }

  handleChange = () => {
    const [tree = null] = this.state.tree || []
    this.props.onChange(tree)
  }

  updateItem = component => (options) => {
    Object.assign(component, options)
    this.setState({})
  }

  createItem(item, from) {
    item = { ...item }
    if (from === 'pallet')
      item.data === null

    return item
  }

  handleSetTree = (action, { from, fromPosition, to, toPosition, extra, item }) => {
    const add = data => {
      const hasChildren = data && data.length > 0 ? true : false
      const newItem = this.createItem(item, from)

      if (extra === 'addLastPosition' && hasChildren) {
        data.push(newItem)
      }
      if (extra === 'addLastPosition' && !hasChildren) {
        data = [newItem]
      }
      if (extra === 'addToPosition' && hasChildren) {
        data.splice(toPosition, 0, newItem)
      }
      if (extra === 'addReplacing' && hasChildren) {
        data.splice(toPosition, 1, newItem)
      }

      return data
    }
    const recursive = (data, path) => {
      const newData = data.map((component, index) => {
        let fullPath = path + `-${index}`

        if (fullPath === from || fullPath === to) {

          if (action === 'delete' || action === 'move') {
            const haveManyChildren = component.data.length > 1 ? true : false
            if (haveManyChildren) component.data.splice(fromPosition, 1)
            if (!haveManyChildren) component.data = null
          }

          if (action === 'add' || action === 'move') {
            component.data = add(component.data)
          }

        } else {
          if (component.data) recursive(component.data, fullPath)
        }

        return component
      })

      return newData
    }

    let { tree } = this.state

    if (action === 'delete' && from === 'root') {
      const haveManyChildren = tree.length > 1 ? true : false
      if (haveManyChildren) tree.splice(fromPosition, 1)
      if (!haveManyChildren) tree = null

    } else if ((action === 'add' || action === 'move') && to === 'root' && toPosition === 'card') {
      tree = add(tree)
    } else {
      tree = recursive(tree, 'root')
    }

    this.setState({ tree }, this.handleChange)
  }

  ItemsRender = ({ data, path }) => {
    return <div>
      {data.map((component, index) => {
        let fullPath = path + `-${index}`
        const Item = items[component.model || component.type]

        return <Item
          key={fullPath}
          component={component}
          path={path}
          id={index}
          handleSetTree={this.handleSetTree}
          updateItem={this.updateItem(component)}
        >
          {
            component.data ?
              <this.ItemsRender
                data={component.data}
                path={fullPath}
              /> :
              null
          }
        </Item>
      })}
    </div>
  }

  render() {
    return <Row className="form-fields">
      <DndContext>
        <Col size="3" className='border-r-1 pr-2 twy-border-base'>
          <span className='text-md'>Components</span>
          <List border className='pl-0!'>
            <items.list block />
            <items.object block />
            <items.property block />
            <items.option block />
            <items.optionList block />
          </List>
        </Col>

        <Col size="9">
          <div className='text-md mb-2'>Data Structure</div>
          {this.state.tree !== null ? <>
            <this.ItemsRender
              data={this.state.tree}
              path="root"
            />
          </> : <>
            <DndCardDrop
              path="root"
              id={0}
              acceptChildren={[TYPE_OBJECT, TYPE_LIST]}
              handleSetTree={this.handleSetTree}
            />
          </>}
        </Col>
      </DndContext>
    </Row>
  }
}

MappingBuilder.propTypes = propTypes
MappingBuilder.defaultProps = {}